import {resolveIdentifier, types} from "mobx-state-tree";
import Parameter from "../../../../models/Parameter";
import lodash from "lodash";
import GS1ParamsStore from "../../../../stores/domain/parameters/GS1ParamStore";

export const GS1ParamsTypeSelectState = types.model('GS1ParamsTypeSelectState',{
  selectStateUuid: types.identifier,
  store: types.maybe(types.reference(GS1ParamsStore)),
  selectedGS1Parameters: types.optional(types.array(types.safeReference(Parameter)), []),
}).volatile((self)=>({
  notifySelect: types.str,
})).actions((self) => ({
  setConsumer(f){
    self.notifySelect = f
  },
  selectParameters(e) {
    if (lodash.isArray(e)) {
      self.selectedGS1Parameters = e?.map(g => {
        return resolveIdentifier(Parameter, self, g?.uuid || g)
      })
    } else if (e) {
      self.selectedGS1Parameters = e
    }
  },
})).views( (self) => ({
  options() {
    return self.store.getGS1Parameters() || [];
  },

}))
